import script from "./InformationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationDialog.vue?vue&type=script&setup=true&lang=js"

import "./InformationDialog.vue?vue&type=style&index=0&id=16a115ed&lang=scss"

const __exports__ = script;

export default __exports__